/**
 * @generated SignedSource<<0d8d1c4041b8c571d78025185651bbc0>>
 * @relayHash 303db69a62b21a40b9f93c2e58eb9bbe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 84fefa0f8f50aa6bb57e6fe4de08b1a51c3b1c9ecc65d539bea2cc0ca96cb33e

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type HierarchyToggleOldMutation$variables = {
  isHierarchyEnabled: boolean;
  viewId: string;
};
export type HierarchyToggleOldMutation$data = {
  readonly jira: {
    readonly updateIssueSearchHierarchyPreference: {
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type HierarchyToggleOldMutation = {
  response: HierarchyToggleOldMutation$data;
  variables: HierarchyToggleOldMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isHierarchyEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v2 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "isHierarchyEnabled",
            "variableName": "isHierarchyEnabled"
          },
          {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
          }
        ],
        "concreteType": "JiraIssueSearchHierarchyPreferenceMutationPayload",
        "kind": "LinkedField",
        "name": "updateIssueSearchHierarchyPreference",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HierarchyToggleOldMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "HierarchyToggleOldMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "84fefa0f8f50aa6bb57e6fe4de08b1a51c3b1c9ecc65d539bea2cc0ca96cb33e",
    "metadata": {},
    "name": "HierarchyToggleOldMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4458c9cdea960a19efa33d2951c511cf";

export default node;
